/**
 * WidgetPage.jsx
 * ─────────────────────────────────────────────────────────────────────────────
 * Route: /widget
 *
 * This is the page served inside the iframe injected by spark-embed.js.
 * It intentionally runs OUTSIDE the main app's MsalProvider so it manages
 * its own MSAL lifecycle (the embed runs on foreign origins).
 *
 * Add this route to your router like so (no other files change):
 *
 *   import WidgetPage from "./pages/WidgetPage";
 *   // Inside your <Routes>:
 *   <Route path="/widget" element={<WidgetPage />} />
 *
 * New file – zero changes to existing routing or auth files.
 */

import React from "react";
import SparkWidget from "../components/SparkWidget/SparkWidget";
import { useEffect } from "react";
import UsageLogService from "../services/UsageLogService";

export default function WidgetPage() {
    // Track page view for analytics
    useEffect(() => {
        // WidgetPage runs outside Teams context (embedded iframe)
        // Track with minimal metadata since Teams SDK not available
        UsageLogService.trackPageView('WidgetPage', null );
    }, []);

  return <SparkWidget />;
}
